import { render, staticRenderFns } from "./BlogPaginationList.vue?vue&type=template&id=41e2c329&"
import script from "./BlogPaginationList.vue?vue&type=script&lang=js&"
export * from "./BlogPaginationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports